import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { CustomListBaseComponent } from '../../../ui-framework/core-controls/custom-list-base/custom-list-base.component';
import { ApiDataService } from '../../../data-services/api-data.service';
import { SelectionListComponent } from "../../../ui-framework/core-controls/selection-list-base/selection-list.component";
import { ColDef } from "ag-grid-community";
import { TrainingCategory } from '../../../data-services/api-models/tms-service-models';

@Component({
  selector: 'app-training-theme-selection-list',
  imports: [SelectionListComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TrainingThemeSelectionListComponent),
      multi: true
    }
  ],
  templateUrl: './training-theme-selection-list.component.html',
  styleUrl: './training-theme-selection-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainingThemeSelectionListComponent extends CustomListBaseComponent<TrainingCategory> implements ControlValueAccessor {

  // private readonly popupColumns: ColDef<TrainingCategory>[] = [
  //   {
  //     field: 'description', headerName: 'Name', flex: 2
  //   }
  // ];
  private readonly popupColumns: ColDef<TrainingCategory>[] = [
    {
      headerName: 'Description',
      flex: 1,
      minWidth: 200,
      tooltipValueGetter: (params) =>
        `${params.data?.description}`,
      valueGetter: (params) =>
        `${params.data?.description}`,
    }
  ];


  constructor(private readonly apiDataService: ApiDataService) {
    super();

  }

  protected override modelChanged(newModel: any) {
    this.currentModel = newModel;
    const valueToEmit =
      typeof newModel === 'object' ? newModel?.id : newModel;

    this.ngModelChange.emit(valueToEmit);
  }

  private setupConfig() {
    this.currentConfig.displayFormatter = (r) => this.displayFormatter(r);
    this.currentConfig.label = 'Training Theme'
    this.currentConfig.listColumns = this.popupColumns;
    this.currentConfig.dataSource = () => this.getMasters()
    this.currentConfig.popupSize = 'Short';
    this.currentConfig.rowFilter = (param: TrainingCategory) => true
    this.refreshConfig();
  }

  ngOnInit() {
    this.setupConfig();
  }

  private getMasters(): Observable<TrainingCategory[]> {
    return this.apiDataService.tmsMastersApi.getTrainingTheme()
  }



  private readonly displayFormatter = (item: TrainingCategory) => `${item?.description}`;

}



